import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { useLocalization } from '../contexts/LocalizationContext';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface LanguageOption {
  code: 'en' | 'ja' | 'cn';
  name: string;
  nativeName: string;
}

const languages: LanguageOption[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  { code: 'cn', name: 'Chinese', nativeName: '中文' },
];

export const LanguageSelector: React.FC<{
  // isSelectDropdown?: boolean;
  dropdownColor?: string;
}> = ({
  // isSelectDropdown,
  dropdownColor = 'text.primary',
}) => {
  const { locale, setLocale, getCurrentLanguageCode } = useLocalization();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageSelect = (languageCode: 'en' | 'ja' | 'cn') => {
    setLocale(languageCode);
    handleClose();
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{
          height: "40px",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: dropdownColor,
        }}
      >
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            color: dropdownColor,
          }}
        >
          {getCurrentLanguageCode()}
        </Typography>
        <ArrowDropDownIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: '8px',
            mt: 1,
            minWidth: '120px',
          },
        }}
      >
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageSelect(language.code)}
            selected={locale === language.code}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              py: 1,
              px: 2,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {language.nativeName}
            </Typography>
            <Typography variant="caption" sx={{ color: '#666', fontSize: '10px' }}>
              {language.name}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}; 